var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ('hw' in _vm.user)?_c('SWUpdatePage'):_c('UpdatePage')}
var staticRenderFns = []

export { render, staticRenderFns }